import { Link } from "react-router-dom";
import { ArrowRight, Heart } from "lucide-react";
import { BLOG_POSTS } from "../../data/blogPosts";
import { SectionEyebrow } from "../SectionEyebrow";

export const FeaturedBlog = () => (
    <section className="py-20 lg:py-28 bg-white" data-testid="home-blog-section">
        <div className="container-fe">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <SectionEyebrow>Historias y noticias</SectionEyebrow>
                    <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-tight">
                        Lo último del territorio.
                    </h2>
                </div>
                <Link to="/blog" className="btn-ghost-pill" data-testid="home-blog-all-cta">
                    Ver todas las publicaciones <ArrowRight size={16} />
                </Link>
            </div>
            <div className="mt-14 grid md:grid-cols-3 gap-6">
                {BLOG_POSTS.slice(0, 3).map((p) => (
                    <Link
                        key={p.slug}
                        to={`/blog/${p.slug}`}
                        data-testid={`home-blog-card-${p.slug}`}
                        className="group rounded-2xl overflow-hidden border border-black/5 bg-white hover:border-brand-green/30 transition-all hover:-translate-y-1"
                    >
                        <div className="aspect-[4/3] overflow-hidden bg-muted">
                            <img
                                src={p.image}
                                alt={p.title}
                                style={p.imagePosition ? { objectPosition: p.imagePosition } : undefined}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                        <div className="p-6">
                            <div className="text-xs uppercase tracking-wider font-bold text-brand-green">{p.category}</div>
                            <h3 className="mt-3 font-display font-semibold text-brand-navy text-lg leading-snug group-hover:text-brand-green transition-colors">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{p.excerpt}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);

export const FinalCTA = () => (
    <section className="py-20 lg:py-28">
        <div className="container-fe">
            <div className="relative rounded-3xl overflow-hidden bg-brand-green p-10 lg:p-16 grid lg:grid-cols-2 gap-10 items-center">
                <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-white/10" />
                <div className="absolute -bottom-32 -left-10 h-80 w-80 rounded-full bg-brand-navy/30" />
                <div className="relative z-10">
                    <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
                        Tu apoyo abre puertas que estaban cerradas.
                    </h2>
                    <p className="mt-5 text-white/85 leading-relaxed text-lg">
                        Cada donación, cada hora voluntaria, cada gesto se convierte en una oportunidad real para alguien que la necesita.
                    </p>
                </div>
                <div className="relative z-10 flex flex-wrap gap-3 lg:justify-end">
                    <Link to="/donar" className="btn-primary-pill bg-white !text-brand-green hover:bg-brand-cream" data-testid="cta-donate">
                        <Heart size={16} className="fill-brand-green" /> Donar
                    </Link>
                    <Link
                        to="/voluntariado"
                        className="rounded-full px-7 py-3.5 text-sm font-semibold text-white border-2 border-white/40 hover:bg-white/10 transition-all"
                        data-testid="cta-volunteer"
                    >
                        Ser voluntario
                    </Link>
                </div>
            </div>
        </div>
    </section>
);
